<template>
  <div>
    <page-header>
      <template #breadcrumbs>
        <router-link to="/journals">Журнал ЛРАС</router-link> &raquo;
        <template v-if="patient">
          <router-link :to="{ path: '/journal/edit/' + patient.id }">{{ patient.surname }} {{ patient.name }} {{ patient.patronimic }}</router-link> &raquo;
        </template> 
        <template v-if="patient">
          <router-link :to="{ path: '/journal/edit/' + patient.id, query: { tab: 'tab2'}}">ИППСУ</router-link> &raquo;
        </template>
        <span>Карточка ИППСУ</span>
      </template>
      <h2>Карточка ИППСУ</h2>
    </page-header>
    <div class="card">
      <div>
        <div v-if="patient" v-disable-all="isReadonly">
          <div class="row mt-2">
            <div class="col-md-3">
              <div class="form-group required">
                <label class="control-label">Дата составления</label>
                <div>
                  <date-component :disabled="isReadonly" v-model="ippsu.date" :required="true" />
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
              <component-input
                  placeholder=""
                  label="№ ИППСУ"
                  required
                  v-model="ippsu.ippsuNumber"
              />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                            <label class='control-label'>Файл ИППСУ</label>
                            <file-upload width="100%" :entity="ippsu"
                                @deleteFile="removeFile"
                                prop-name="file"
                                @uploaded="fileUploaded"/>
                            </div>

            </div>
            <div class="col-md-3">
              <div class="form-group">
              <component-input
                  placeholder=""
                  label="№ карты"
                  required
                  v-model="ippsu.num"
              />
              </div>
            </div>
          </div>

          <dropdown>
            <template v-slot:title>
                <strong>Общая информация</strong>
            </template>            
            <template v-slot:default>
              <div>
                <div class="row mt-2">
                  <div class="col-md-4">
                    <component-input
                      disabled
                      placeholder=""
                      label="Фамилия"
                      required
                      v-model="patient.surname"
                    />
                  </div>
                  <div class="col-md-4">
                    <component-input
                      disabled
                      placeholder=""
                      label="Имя"
                      required
                      v-model="patient.name"
                    />
                  </div>
                  <div class="col-md-4">
                    <component-input
                      disabled
                      placeholder=""
                      label="Отчество"
                      v-model="patient.patronimic"
                    />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-4">
                    <div class="form-group form-group--select required">
                      <label class="control-label">Пол</label>
                      <Select2
                        disabled
                        placeholder="Не указано"
                        class="select2"
                        :options="gender"
                        v-model="patient.male"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="control-label">Дата рождения</label>
                      <div>
                        <date-component v-model="patient.dateOfBirth" disabled :clearable="false" />
                      </div>
                    </div>
                  </div>
                </div>

                <h4 class="mt-3">Адрес места жительства:</h4>
                <div class="row mt-2">
                  <div class="col-md-4">
                    
                    <component-input
                      placeholder=""
                      label="Индекс"
                      v-model="ippsu.homeAddressIndex"
                    />
                  </div>
                  <div class="col-md-4">
                    <component-input
                      placeholder=""
                      label="Город (район)"
                      v-model="ippsu.homeAddressCity"
                    />
                  </div>
                  <div class="col-md-4">
                    <component-input
                      placeholder=""
                      label="Улица"
                      v-model="ippsu.homeAddressStreet"
                    />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-4">
                    <component-input
                      placeholder=""
                      label="Дом №"
                      v-model="ippsu.homeAddressDom"
                    />
                  </div>
                  <div class="col-md-4">
                    <component-input
                      placeholder=""
                      label="Корпус"
                      v-model="ippsu.homeAddressKorp"
                    />
                  </div>
                  <div class="col-md-4">
                    <component-input
                      placeholder=""
                      label="Квартира"
                      v-model="ippsu.homeAddressKv"
                    />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-4">
                    <component-input
                      placeholder=""
                      label="Телефон"
                      v-model="ippsu.homeAddressPhone"
                    />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-4">
                    <component-input
                      placeholder=""
                      label="Адрес электронной почты"
                      
                      v-model="ippsu.email"
                    />
                  </div>
                </div>

                <h4 class="mt-3">Адрес места работы:</h4>
                <div class="row mt-2">
                  <div class="col-md-4">             
                    <component-input
                      placeholder=""
                      label="Индекс"
                      v-model="ippsu.workAddressIndex"
                    />
                  </div>
                  <div class="col-md-4">
                    <component-input
                      placeholder=""
                      label="Город (район)"
                      v-model="ippsu.workAddressCity"
                    />
                  </div>
                  <div class="col-md-4">
                    <component-input
                      placeholder=""
                      label="Улица"
                      
                      v-model="ippsu.workAddressStreet"
                    />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-4">
                    <component-input
                      placeholder=""
                      label="Дом №"
                      
                      v-model="ippsu.workAddressDom"
                    />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-4">
                    <component-input
                      placeholder=""
                      label="Телефон"
                      
                      v-model="ippsu.workAddressPhone"
                    />
                  </div>
                </div>

                <h4 class="mt-3">Паспортные данные:</h4>
                <div class="row mt-2">
                  <div class="col-md-4">
                    <component-input
                      placeholder=""
                      label="Серия"
                      
                      v-model="ippsu.docSerial"
                    />
                  </div>
                  <div class="col-md-4">
                    <component-input
                      placeholder=""
                      label="Номер"
                      
                      v-model="ippsu.docNum"
                    />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="control-label">Дата выдачи</label>
                      <div>
                        <date-component :disabled="isReadonly" v-model="ippsu.docDate" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <component-input
                      placeholder=""
                      label="Кем выдан"
                      
                      v-model="ippsu.docIssuer"
                    />
                  </div>
                  <div class="col-md-4">
                    <component-input
                      placeholder=""
                      label="Код подразделения"
                      
                      v-model="ippsu.docDeptCode"
                    />
                  </div>
                </div>

                
              </div>
            </template>
          </dropdown>


          
          
          <div class="row mt-2" v-if="ippsu.id">
            <div class="col-md-6">
              <p>
                ИППСУ разработана <b>{{ ippsu.ippsuType ?? ippsu.isFirst ? "впервые" : "повторно" }}</b>
                <template v-if="ippsu.journalIppsuServices.length && ippsu.journalIppsuServices[0].endDate"> на срок до {{ $momentFormat(ippsu.journalIppsuServices[0].endDate, "DD.MM.YYYY") }}</template>
              </p>
            </div>
          </div>
          <div class="row mt-2" v-if="ippsu.id">
            <div class="col-md-6">
              <p>
                Форма (формы) социального обслуживания:
                <b>{{ ippsu.journalIppsuServices.map(x => x.socialTypeInfo ).filter((v, i, a) => a.indexOf(v) === i).join(', ') }}</b>
              </p>
            </div>
          </div>

          <div v-if="ippsu.journalIppsuServices && ippsu.journalIppsuServices.length" class="mb-4">
            <div class="service-header-with-filter">
              <p class="service-header">Виды социальных услуг</p>
              <div>                
                      <Select2
                        placeholder="все"
                        class="select2"
                        data-ignore-disable="true"
                        :options="ippsuServiceEndTypes"
                        v-model="ippsuServiceEndType"
                      />
              </div>
            </div>
            
            <div class="table-inner">
            <table class="table-custom">
              <thead>
                <tr>
                  <th width="6%">№ п/п</th>
                  <th>Наименование услуги</th>
                  <th>Форма социального обслуживания</th>
                  <th>Тип услуги</th>
                  <th>Рекомендуемые поставщики</th>
                  <th>Периодичность предоставления услуги</th>
                  <th>Срок предоставления услуги</th>
                  <!-- <th>Отметка об окончании предоставлении услуги</th> -->
                  <th>Причины отказа</th>
                  <th>Дата отказа</th>
                  <th>Кто отказал</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="journalIppsuServicesFilter && journalIppsuServicesFilter.length > 0">
                <tr v-for="(service, index) in journalIppsuServicesFilter" :key="service.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ service.serviceName }}</td>
                  <td>{{ service.socialTypeInfo }}</td>
                  <td>{{ service.serviceType }}</td>
                  <td>{{ service.recommendedSuppliers }}</td>
                  <td>{{ service.period }}</td>
                  <td>{{ $momentFormat(service.endDate, "DD.MM.YYYY") }}</td>
                  <!-- <td>
                    <template v-if="ippsu.isResultMarker">Услуга завершена</template>
                  </td> -->
                  <td>{{ service.refuseReason }}</td>
                  <td>{{ service.refuseDate }}</td>
                  <td>{{ service.refusedBy }}</td>
                </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="10">Ничего не найдено.</td>
                  </tr>
                </template>
              </tbody>
            </table>
            </div>
          </div>

          <div v-if="ippsu.journalIppsuContracts && ippsu.journalIppsuContracts.length">
            <p class="service-header">Заключенные договоры</p>
            <div class="table-inner">
            <table class="table-custom">
              <thead>
                <tr>
                  <th width="6%">№ п/п</th>
                  <th>Дата заключения договора</th>
                  <th>Номер договора</th>
                  <th>Дата начала обслуживания по договору</th>
                  <th>Дата окончания обслуживания по договору</th>
                  <th>Краткое наименование организации</th>
                  <th>ИНН организации</th>
                  <th>КПП организации</th>
                  <th>Адрес места нахождения поставщика социальных услуг</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(contract, index) in ippsu.journalIppsuContracts" :key="contract.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ getNonEmptyDate(contract.contractDate) }}</td>
                  <td>{{ contract.contractNumber }}</td>
                  <td>{{ getNonEmptyDate(contract.contractStartDate) }}</td>
                  <td>{{ getNonEmptyDate(contract.contractEndDate) }}</td>
                  <td>{{ contract.organizationName }}</td>
                  <td>{{ contract.organizationInn }}</td>
                  <td>{{ contract.organizationKpp }}</td>
                  <td>{{ contract.organizationAddress }}</td>
                </tr>
              </tbody>
            </table>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="float-right  d-flex align-items-center">
            <button-component
              class="btn btn-primary mx-2"
              v-on:click="save"
              v-if="!isReadonly"
            >
              Сохранить
            </button-component>
            <button-component type="button" kind="secondary" class="btn btn-default" v-on:click="close">
              Закрыть
            </button-component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/common/components/page/PageHeader";
import ComponentInput from "@/common/components/ComponentInput";
import DateComponent from "@/common/components/DateComponent";
import IppsuApi from "../api/ippsu";
import JournalApi from "../api/journal";
import RasApi from "@/modules/ras/api/ras";
import FileUpload from "@/common/components/FileUpload";
import Constants from "@/common/constants";
import {useVuelidate} from '@vuelidate/core'
import ButtonComponent from "../../../common/ui/ButtonComponent";
import disableAll from "../../../common/directives/disable-all";
import Dropdown from "@/modules/journal/components/Dropdown";
import moment from "moment";

export default {
  name: "IppsuCard",
  components: {
    ButtonComponent,
    PageHeader,
    ComponentInput,
    DateComponent,
    FileUpload,
    Dropdown
  },
  directives: {
    'disable-all': disableAll
  },
  data() {
    return {
      isReadonly: this.$route.params.action === "view",
      ippsu: null,
      journal: null,
      patient: null,
      gender: [
        { id: true, text: "Мужчина", value: 1 },
        { id: false, text: "Женщина", value: 0 },
      ],
      serviceForms: [],
      ippsuServices: [],
      ippsuServiceTypes: [],
      minDate: moment.utc("0001-01-01"),

      ippsuServiceEndType: "1",
      ippsuServiceEndTypes: [
        {id: "1", text: "все", selected: true},
        {id: "2", text: "незавершенные", selected: false},
        {id: "3", text: "завершенные", selected: false}
      ],
      journalIppsuServicesFilter: []
    };
  },
  created() {
    const vm = this;
    if (this.$route.params.action === "add") {
      vm.initIppsu();
      JournalApi.find(vm.ippsu.patientId).then((response) => {
        vm.journal = response.data;
        vm.ippsu.journalId = vm.journal.id;
        RasApi.find(vm.journal.patientId).then((response) => {
          vm.patient = response.data;
          vm.setPatientData();
        });
      });
    } else {
      IppsuApi.find(this.$route.params.id).then((response) => {
        vm.ippsu = response.data;
        vm.journalIppsuServicesFilter = vm.ippsu.journalIppsuServices;
        JournalApi.find(vm.ippsu.patientId).then((response) => {
          vm.journal = response.data;
          RasApi.find(vm.journal.patientId).then((response) => {
            vm.patient = response.data;
          });
        });
      });
    }
    JournalApi.getNsi("IppsuService").then((response) => {
      vm.ippsuServices = response.data;
    });
    JournalApi.getNsi("IppsuServiceType").then((response) => {
      vm.ippsuServiceTypes = response.data;
    });
    JournalApi.getNsi("ServiceForm").then((response) => {
      vm.serviceForms = response.data;
    });
  },
  methods: {
    filterIppsuService() {
      var now = new Date().toISOString().split('T')[0] + "T00:00:00";
      if(this.ippsuServiceEndType == "1")
        this.journalIppsuServicesFilter = this.ippsu.journalIppsuServices;
      else if(this.ippsuServiceEndType == "2")//незавершенные
        this.journalIppsuServicesFilter = this.ippsu.journalIppsuServices.filter(x => x.refuseDate == "" && x.endDate >= now);
      else if(this.ippsuServiceEndType == "3")//завершенные
        this.journalIppsuServicesFilter = this.ippsu.journalIppsuServices.filter(x => x.refuseDate != "" || x.endDate < now);
    },
    save() {
      const vm = this;

      vm.v$.$touch();
      if (vm.v$.$invalid) {
        Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
        return;
      }

      if (vm.ippsu.id) {
        IppsuApi.update(vm.ippsu.id, vm.ippsu).then((response) => {
          console.log(response);
          Constants.alert.fire("Данные сохранены.", "Успешно", "success");
        }).catch((error) => {
          Constants.alert.fire("Ошибка", error.data, "error");
        });
      } else {
        IppsuApi.create(vm.ippsu).then((response) => {
          Constants.alert.fire("Данные сохранены.", "Успешно", "success");
          console.log(response);
          this.$router.push({
            name: "ippsuCard",
            params: {
              patient_id: vm.patient.id,
              action: "edit",
              id: response.data.id,
            },
          });
        }).catch((error) => {
          Constants.alert.fire("Ошибка", error.data.message, "error");
        });
      }
    },
    close() {
      this.$router.push('/journal/edit/' + this.patient.id);
    },
    initIppsu() {
      this.ippsu = {
        id: null,
        date: this.$momentFormat(new Date(), 'YYYY-MM-DD'),
        num: "100000001",
        homeAddressIndex: "",
        homeAddressCity: "",
        homeAddressStreet: "",
        homeAddressDom: "",
        homeAddressKv: "",
        homeAddressKorp: "",
        homeAddressPhone: "",
        workAddressIndex: "",
        workAddressCity: "",
        workAddressStreet: "",
        workAddressDom: "",
        workAddressPhone: "",
        docSerial: "",
        docNum: "",
        docDate: null,
        docIssuer: "",
        docDeptCode: "",
        email: "",
        isLockedForUpdate: false,
        journalId: null,
        journalIppsuServices: [],
        journalIppsuProviders: [],
        journalIppsuMaintenance: [],
        patientId: this.$route.params.patient_id,
      };
    },
    setPatientData() {
      const ippsu = this.ippsu;
      const patient = this.patient;
      patient.patientAddresses.forEach((addr) => {
        if (addr.addressType.name === "Residence") {
          ippsu.homeAddressIndex = addr.postalCode;
          ippsu.homeAddressCity = addr.city;
          ippsu.homeAddressStreet = addr.street;
          ippsu.homeAddressDom = addr.house;
          ippsu.homeAddressKv = addr.room;
          ippsu.homeAddressKorp = addr.housing;
          ippsu.homeAddressPhone = addr.phone;
        } else if (addr.addressType.name === "WorkPlace") {
          ippsu.workAddressIndex = addr.postalCode;
          ippsu.workAddressCity = addr.city;
          ippsu.workAddressStreet = addr.street;
          ippsu.workAddressDom = addr.house;
          ippsu.workAddressPhone = addr.phone;
        }
      });
      if (patient.passportDt) {
        ippsu.docSerial = patient.passportSerie;
        ippsu.docNum = patient.passportNum;
        ippsu.docDate = patient.passportDt;
        ippsu.docIssuer = patient.passportWhere;
        ippsu.docDeptCode = patient.passportDep;
      } else {
        ippsu.docSerial = patient.birthCertSerie;
        ippsu.docNum = patient.birthCertNum;
        ippsu.docDate = patient.birthCertDt;
      }
      ippsu.email = patient.email;
    },

        removeFile() {
            this.ippsu.fileId = null
        },
        fileUploaded(e) {
      console.log(e)
            this.ippsu.file = e.data;
            this.ippsu.fileId = e.data ? e.data.id : null;
      },
    getNonEmptyDate(date) {
      return moment.utc(date).isAfter(this.minDate) ? this.$momentFormat(date, "DD.MM.YYYY") : "";
    }
  },
  computed: {
    usedServiceForms() {
      return this.ippsu.journalIppsuServices
        .map((x) => x.serviceFormId)
        .join(", ");
    },
  },
  watch: {
    ippsuServiceEndType: function (/*newValue, oldValue*/) {
      this.filterIppsuService();
    },
  },
  setup: () => ({v$: useVuelidate()}),
    validations() {
        return {
            ippsu: {
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.table-tmp {
  border-collapse: collapse;
  th,
  td {
    border: 1px solid black;
  }
}
@import '/src/assets/theme/default/colors.scss';

    .form-group.required .control-label:after {
        content:" *";
        color:red;
    }
    .form-check.required .control-label:after {
        content:" *";
        color:red;
    }
    .invalid-msg {
        color:red;
        font-size: 0.75rem;
    }
    .select2::v-deep {
        .select2-container {
            width: 100% !important;
            max-width: 100% !important;
        }

        .select2-container--default .select2-selection--single {
            height: calc(2.25rem + 2px) !important;
        }

        .select2-container--default .select2-selection--single .select2-selection__arrow {
            top: 7px !important;
        }
    }
    .card {
        padding: 24px;
        margin: 10px 24px 0 24px;
        border-radius: 24px;
        border: none;
        box-shadow: none;
        &-footer{
            padding-top: 1rem !important;
            background-color: transparent;
            border: none
        }
    }

    h4 {
    font-size: 18px;
    margin: 0;
}

.service-header {
  font-weight: 700;
  font-size: 1.2rem;
}

.service-header-with-filter {
  display: flex;
  justify-content: space-between;
}
.service-header-with-filter .select2 {
  min-width: 170px;
}
</style>